<template>
  <section id="support" class="spacer">
    <div class="title big">{{ support.title }}</div>
    <div class="pt big" v-html="support.textarea"></div>
  </section>
</template>

<script>
import API from "@/api/service";
export default {
  data() {
    return {
      support: []
    };
  },
  created() {
    API.support(this.$i18n.locale).then(page => {
      this.support = page.data.result;
    });
  }
};
</script>

<style></style>
